import React from 'react'
import { useSessionContext } from 'components/sessions/sessionContext'
import PlayGamePlayer from 'components/play/Players/PlayGamePlayer'
import EvenlySpaced from 'shared/content-control/EvenlySpaced'
import { Button } from 'shared/Buttons'
import { useCreateGame } from 'components/games/queries'
import { navigate } from '@reach/router'
import GameContainer from 'components/play/GameContainer'

const CreateGame = () => {
  const { session } = useSessionContext()
  const { username } = session?.user

  const [createGame] = useCreateGame()
  const [showErrorMessage, setShowErrorMessage] = React.useState(false)

  const createGameOnClick = async ({ numberOfRounds }) => {
    try {
      const { data } = await createGame({
        variables: { numberOfRounds },
      })
      if (data) navigate(`/play/${data.createdGame.id}`)
    } catch (e) {
      // Error occurred
      setShowErrorMessage(true)
    }
  }
  const NewGameButton = ({ numberOfRounds, size, children }) => (
    <Button
      isPrimary={true}
      onClick={() => createGameOnClick({ numberOfRounds })}
      style={{ width: '15rem', margin: '0 auto' }}
    >
      <h1 style={{ margin: 0 }}>{size}</h1>
      {children}
    </Button>
  )
  return (
    <GameContainer>
      <EvenlySpaced.Column
        justifyContent="space-evenly"
        style={{ textAlign: 'center' }}
      >
        <h1>New Game</h1>
        <p>How many rounds?</p>
        <NewGameButton numberOfRounds={5} size="S">
          <div>5 rounds (~5 mins)</div>
        </NewGameButton>
        <NewGameButton numberOfRounds={9} size="M">
          <div>9 rounds (~10 mins)</div>
        </NewGameButton>
        <NewGameButton numberOfRounds={18} size="L">
          <div>18 rounds (~20 mins)</div>
        </NewGameButton>
        {showErrorMessage && <p>Something went wrong, please try again!</p>}
      </EvenlySpaced.Column>
      <PlayGamePlayer player={{ username, totalScore: null }} />
    </GameContainer>
  )
}

export default CreateGame
